import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
} from '@occc/ui-design-system';
import { RetailerNetworkLocationGroupForMemberFragment } from '@occc/graphql';
import { useGetRetailerNetworkLocationGroupsForMember } from '@occc-app/dataAccessLayer/membership/queries';

import { RetailerNetworkLocationGroupsForMemberRow } from './RetailerNetworkLocationGroupsForMemberRow';

type RetailerNetworkLocationGroupsForMemberTableProps = {
  employeeLocationGroups: ReturnType<typeof useGetRetailerNetworkLocationGroupsForMember>;
};

export const RetailerNetworkLocationGroupsForMemberTable = ({
  employeeLocationGroups,
}: RetailerNetworkLocationGroupsForMemberTableProps) => {
  const { loading, error, data, paginationProps } = employeeLocationGroups;

  const renderData = (items: RetailerNetworkLocationGroupForMemberFragment[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Group Name</TableCell>
            <TableCell>Locations</TableCell>
            <TableCell>Employee Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((locationGroup) => (
            <RetailerNetworkLocationGroupsForMemberRow
              key={locationGroup.uuid}
              locationGroup={locationGroup}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<RetailerNetworkLocationGroupForMemberFragment>
      error={error}
      loading={loading}
      items={data}
      renderData={renderData}
    />
  );
};
